var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.995361 21.5884C3.25605 27.6812 9.12074 32.0232 16.0002 32.0232C22.8796 32.0232 28.7443 27.6812 31.005 21.5884L16.0002 20.1972L0.995361 21.5884Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 0.0234375C9.12074 0.0234375 3.25605 4.36544 0.995361 10.4583L16.0002 11.8495L31.005 10.4582C28.7443 4.36544 22.8796 0.0234375 16.0002 0.0234375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995188 10.4582C0.352063 12.1915 0 14.0663 0 16.0234C0 17.9805 0.352063 19.8553 0.995188 21.5886H31.0049C31.648 19.8553 32 17.9805 32 16.0234C32 14.0663 31.648 12.1915 31.0048 10.4582H0.995188Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.38bd4f6c.svg";
export { ForwardRef as ReactComponent };